module.exports = __webpack_public_path__ + "img/product-banner-2.84858b6f.png";